import { useState } from "react";
import { customerServices } from "@/services/customerServices";
import Layout from "@/components/layout";
import Faq from "@/components/faq";
import Testimonial from "@/components/customer/testimonials";
import { useRouter,pathName } from "next/router";
import ReikiDetail from "@/components/services/reiki";
import ThetaDetail from "@/components/services/theta";
import HealingTouch from "@/components/services/healing-touch";
import { healerServices } from "@/services/healerServices";
import Head from 'next/head';

const ServicesDetail = (props) => {
    const [healingTouchServicesMeta, setHealingTouchServicesMeta] = useState(props?.healingTouchServicesMeta ?? {});
    const router = useRouter();
    const [testimonials, setTestimonial] = useState(props?.testimonials ?? []);

    return (
        <>
        <Head>
        <title>{healingTouchServicesMeta?.meta?.og_title}</title>
        <meta name="title" content={healingTouchServicesMeta?.meta?.meta_title}></meta>
        <meta name="description" content={healingTouchServicesMeta?.meta?.meta_description}></meta>
        <meta name="keywords" content={healingTouchServicesMeta?.meta?.meta_keywords}></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:title" content={healingTouchServicesMeta?.meta?.og_title}></meta>
        <meta property="og:image" content={healingTouchServicesMeta?.meta?.og_image}></meta>
        <meta property="og:description" content={healingTouchServicesMeta?.meta?.meta_description}></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={healingTouchServicesMeta?.meta?.meta_title} />
        <meta name="twitter:description" content={healingTouchServicesMeta?.meta?.meta_description}/>
        <meta name="twitter:image" content={healingTouchServicesMeta?.meta?.og_image} />
        <meta property="og:url" content={router?.asPath === "/services/healing-touch"?"https://www.zenkify.com/services/healing-touch":router?.asPath === "/services/theta-healing"?"https://www.zenkify.com/services/theta-healing":"https://www.zenkify.com/services/reiki-healing"} />
        <meta property="og:site_name" content="Zenkify" />
        <meta property="og:image:alt" content="zenkify reiki, theta & healing touch services" />
        <meta property="og:image" content={healingTouchServicesMeta?.meta?.og_image}></meta>
        <link rel="canonical" href={router?.asPath === "/services/healing-touch"?"https://www.zenkify.com/services/healing-touch":router?.asPath === "/services/theta-healing"?"https://www.zenkify.com/services/theta-healing":"https://www.zenkify.com/services/reiki-healing"}></link>
        </Head>
            {router?.asPath === "/services/healing-touch" ? (
                <HealingTouch />
            ) : router?.asPath === "/services/theta-healing" ? (
                <ThetaDetail />
            ) : (
                <ReikiDetail />
            )}

            
            <Testimonial props={{ testimonials }} />
        </>
    );
};

export default ServicesDetail;

ServicesDetail.getLayout = function getLayout(page) {
    return <Layout>{page}</Layout>;
};

// ssr
export async function getServerSideProps(context) {
    const { resolvedUrl } = context;
    // Pass data to the page via props
    const fetchTestimonials = async () => {
        const res = await customerServices.getTestimonials();
        if (res.status) {
            return res.data;
        } else {
            toast.error(res.message, {
                autoClose: 5000,
            });
        }
    };

    const fetchHealingTouchServicesMeta = async () => {
        try {
          const res = await healerServices.getMetaInformation(resolvedUrl != "/services/healing-touch"? resolvedUrl == "/services/reiki-healing"?"reiki-healing":"theta-healing":"healing-touch");
          if (res.status) {
            return res.data;
          }
        } catch (error) {
          console.error("Error fetching slider data:", error);
        }
      };


    const testimonials = await fetchTestimonials();
    const healingTouchServicesMeta = await fetchHealingTouchServicesMeta()??{};

    return { props: { testimonials, healingTouchServicesMeta } }
}
